import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import logger from "js-logger";
import React from "react";
import layoutComponentsDictionary from "@/components/forms/components/layout/layoutComponentsDictionary";
export var FunctionEditComponents = function (_a) {
    var fieldName = _a.fieldName, fieldDef = _a.fieldDef, record = _a.record, onUpdate = _a.onUpdate, moduleName = _a.moduleName;
    var componentIndex = 0;
    if (fieldName) {
        var componentName = fieldName || "";
        var functionComponentEdit = layoutComponentsDictionary.getLayoutComponent("".concat(componentName, "-edit"));
        if (functionComponentEdit) {
            logger.debug("[LAYOUT SETTINGS] - Utilisation du composant \"".concat(functionComponentEdit.name, "\" pour afficher le settings du type \"").concat(componentName, "\"."));
            return React.createElement(functionComponentEdit, {
                key: "function_edit_".concat(componentIndex++),
                fieldName: fieldName,
                fieldDef: fieldDef,
                record: record,
                onUpdate: onUpdate,
                moduleName: moduleName,
            });
        }
    }
    return _jsx(_Fragment, {});
};
